import { render } from "./WebixUIComponent.vue?vue&type=template&id=b7b9da28"
import script from "./WebixUIComponent.vue?vue&type=script&lang=js"
export * from "./WebixUIComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__